import ResultHeader from "./components/ResultHeader";
import ScoreCard from "./components/ScoreCard";
import SectionWisePerformance from "./components/SectionWisePerformance";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { axiosRequest } from "../../../../_config/apiClient";

export default function Result() {
  const { state } = useLocation();
  const { attemptId } = state || {};
  console.log("Attempt ID:", attemptId);

  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!attemptId) return;

    const fetchResult = async () => {
      console.log("Fetching result for Attempt ID:", attemptId);
      try {
        const res = await axiosRequest(
          "post",
          "/user/getResultTest",
          { attemptId },
          {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        );

        setResultData(res.data);
      } catch (err) {
        console.error("Result fetch error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResult();
  }, [attemptId]);

  if (loading) return <div className="p-10 text-center">Loading Result...</div>;

  if (!resultData) return <div>No result found</div>;

  return (
    <>
      <ResultHeader exam={resultData.exam} overall={resultData.overall} />
      <ScoreCard overall={resultData.overall} />
      <SectionWisePerformance sections={resultData} />
    </>
  );
}
